import { MasterPropertyModel } from "object-models/shared/master-property.model";

export function getEnergyUnits(
    energyTypeList: Array<MasterPropertyModel>,
    selectedType: string
  ): string[] {
    const normalizedSelectedType = selectedType.trim();
    const eType = energyTypeList.find((e) => e.value?.trim() === normalizedSelectedType);
    if (eType) {
      if (eType.note && eType.note?.length > 0) {
        if (eType.note.includes(",")) {
          return eType.note
            .split(",")
            .map((unit) => unit.trim())
            .filter((unit) => unit.length > 0);
        } else {
          const unit = eType.note.trim();
          return unit.length > 0 ? [unit] : [];
        }
      } else return [];
    }
    return [];
  }